import { MoonIcon, SunIcon } from '@sailadv/hdata-ui';

import { AppTheme } from '@/shared/constants/app-theme.constant';

export const USER_MENU_THEME_OPTIONS = [
	{ value: AppTheme.Light, label: 'header.user-menu.theme.light', Icon: SunIcon },
	{ value: AppTheme.Dark, label: 'header.user-menu.theme.dark', Icon: MoonIcon },
] as const;
